@if (!chartReady()) {
  <div class="w-full relative">
  <div class="bg-white rounded rounded-xl h-[400px]">
    <chl-loader
      class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
</div>
} @else {
  <co-chart-card
  [chartHeader]="chartHeader()"
  [cssClass]="cssClass()"
  [filterOptions]="filterOptions()"
  [selectedFilters]="selectedFilters"
  (onFilterChange)="onDropdownChange()"
  [testResult]="testResult()"
 
>
  <!-- begin::Chart-->
  <div chart-content>
@if (hasChartData) 
    {
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [dataLabels]="chartOptions.dataLabels"
      [plotOptions]="chartOptions.plotOptions"
      [responsive]="chartOptions.responsive"
      [title]="chartOptions.title"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [legend]="chartOptions.legend"
      [colors]="chartOptions.colors"
      [fill]="chartOptions.fill"
    ></apx-chart>
    <!--
    <div class="mt-4 text-sm text-gray-700">
      <div style="margin-top: 16px">
        <strong
          >Chi-squared Test for Independence (Group × Approval Status):</strong
        ><br />
        <strong>Chi2 statistic:</strong> {{ statistic }}<br />
        <strong>p-value:</strong> {{ pValue }}<br />
        <strong>Conclusion:</strong>{{ message }}
      </div>
    </div>
  -->
    }   @else
    {
    <div class="flex items-center justify-center">
      <span class="text-black-500 text-lg font-medium">{{"REPORTS.NO_DATA_FOUND" | translate}}</span>
    </div>
    }
  </div>
</co-chart-card>
}